require('./style.less');

var Marionette = require('marionette'),
    BabySitterView = require('../../../common/BabySitterView'),
    Backbone = require('backbone'),
    _ = require('underscore'),
    $ = require('jquery'),
    NewNoteDropDown = require('./createNew/newNoteMenu'),
    NoteFilterView = require('./filter/filterMenu'),
    NoteSortView = require('.//sort/sortMenu'),
    SearchBar = require('../../../common/searchBar/searchBar'),

    RedactionToolbar = require('./shapeDrawingToolbars/redactionTB/redactionToolbar'),
    GraphicNoteToolbar =  require('./shapeDrawingToolbars/graphicNoteTB/graphicShapeToolbar'),

    fvChannel = require('glRadio').channel('FV');


require('jqToggleButton');


module.exports = BabySitterView.extend({

    template: require('./noteHeader.hbs'),
    className: 'sp-head-wr',

    initialize: function(options) {

        _.extend( this, _.pick( options, 'collection', 'channel') );
        this.channel.comply(this.commands, this);

    },

    commands: {

        changeSortIndicator: function(dir) {
            this._setSortDirectionIndicator(dir);
        },

        updateNoteFilterInHeader: function() {

            var $curBtn = this.ui.filterBtn;
            var $bClone = $curBtn.clone()
                .addClass('hide')
                .removeClass('active filterActive') /* active class is separate from the filter active class */
                .insertBefore($curBtn);

            var existingView = this.children.findByCustom('noteFilter');
            existingView.destroy();

            this.ui.filterBtn = $bClone; //or won't be able to re-clone

            this.setFilterIndicatorAndTitle();

            $bClone.toggleClass('filterActive', this.collection.notesAreFiltered() );

            $bClone.removeClass('hide');

            //issue w/destroy is that ui.filterBtn will be null

            var noteFilterView = this._createNoteFilterView({
                hPos: 'right',
                container: this.channel.request('vChannel').request('getWrapper')
            }, this.channel,
                this.ui.filterBtn
            ).render();

            this.children.add(noteFilterView, 'noteFilter');
        }
    },

    onRender: function() {

        this._setSortDirectionIndicator( this.channel.request('noteSortDirection') );
        this.unwrap();

    },

    ui: {
        'searchBarPlaceholder':         '[data-searchWidget]',
        'addPgNoteBtn':                 '#add-pg-note',
        'filterBtn':                    '.filter',
        'sortBtn':                      '.sort',
        'toggleSortBtn':                '.sort-dir',
        'modeWr':                       '#modeWr',
        'noteTypeIcon':                 '.note-type-icn',
        'toolbarContainer':             '.nonSearch',
        'previewRedactionToggleBtn':    '#toggle-preview-redactions'
    },
    events: {

        'click @ui.toggleSortBtn': function() {
            this.channel.command('toggleSortDirection');
        }

    },

    keyboardEvents: {

        // Provide hotkey for the Redaction Preview button.
        // Don't call channel event; utilize the plugin that will update it's UI.
        'p': function() {
            this.ui.previewRedactionToggleBtn.trigger('toggle');
        }

    },

    onBeforeShow: function() {

        var ch = this.channel,
            children = this.children,
            vsWrapper = ch.request('vChannel').request('getWrapper'), //TODO: pass in
            baseDDopts = {
                hPos: 'right',
                container: vsWrapper
            };

        children.add( new NewNoteDropDown({
            el: this.ui.addPgNoteBtn,
            channel: ch,
            ddOptions: _.extend(baseDDopts, {
                ddNoSelect: true
            })
        }), 'addNoteDD')

        .add( this._createNoteFilterView(baseDDopts, ch, this.ui.filterBtn), 'noteFilter')

        .add( new NoteSortView({
            el: this.ui.sortBtn,
            notes: this.collection,
            channel: ch,
            ddOptions: _.extend(baseDDopts, {
                isSelect: true,
                selectNoOpenerText: true
            })
        }), 'sortNotes');

        children.call('render');

        var searchBar = new SearchBar({
            placeHolder: 'Notes',
            preCollapse: function() {
                ch.command('updateFilter', {
                    filterSrc: 'sat',
                    satFilterTxt: '',
                    currentPage: ch.request('currentPageNumber')
                });
            },
            keyUp: function(filterText) {
                ch.command('updateFilter', {
                    filterSrc: 'sat',
                    satFilterTxt: filterText,
                    currentPage: ch.request('currentPageNumber')
                });
            }
        });

        this.ui.searchBarPlaceholder.replaceWith(searchBar.render().$el);
        children.add(searchBar, 'searchView');

        this.setFilterIndicatorAndTitle();

        this._createPreviewRedactionToggleButton();

        this.$el.unselectable();

        return this;

    },
    /* el can change on reset */
    _createNoteFilterView: function(baseDDopts, ch, el) {

        return new NoteFilterView({
            el: el,
            filterModel: ch.request('filterState'),
            notes: this.collection,
            channel: ch,
            ddOptions: _.extend(baseDDopts, {
                ddMultiSelect: true,
                selectNoOpenerText: true
            })
        });

    },

    // factory for the toolbar -- this belongs in another module (mediate)
    createToolbar: function(note, isEdit) {

        this.destroyToolbar();

        var options = {
                note: note,
                isEdit: isEdit,
                channel: this.channel
            },
            fnRenderToolbar = function(toolbar) {
                this.children.add( toolbar, 'toolbar' );
                this.ui.toolbarContainer.append( toolbar.render().el ); //(can't put at end or error will occur for highlight -- TODO: stop b/f gets in)
            };


        if ( note.isNonFullpageRedactionNote() ) {

            this.options.channel.request('currentPageIsCold') && _.extend( options, {
                pageIsCold: true
            });

            fnRenderToolbar.call( this, new RedactionToolbar(options) );
            return;
        }

        if ( note.isSVGGraphicNote() ) {

            fnRenderToolbar.call(this, new GraphicNoteToolbar( _.extend(
                options, {
                    container: this.ui.toolbarContainer
                })
            ) );
        }

    },
    destroyToolbar: function() {  //use destroy as check, could be empty {}
        var toolbar =  this.children.findByCustom('toolbar');
        toolbar && toolbar.destroy(); //(could also trigger)
    },
    enterMode: function(note, mode) {  //mode: edit,create,expanded

        this.$el
            .add(this.ui.modeWr)
            .addClass( mode + ' ' + note.getNoteClass() );

        this.ui.noteTypeIcon.addClass(note.iconClass);

        this.children.findByCustom('searchView')
            .triggerMethod('toggleCollapseAbility') //put back ability to toggle it
            .triggerMethod('forceClose')//(if open, close so can see icons)
            .triggerMethod('toggleEnabled', 0);

        mode !== 'note-expanded' && this.createToolbar(note, false);
    },
    exitModeAllModes: function() {

        this.$el.attr('class', this.className); //remove anything other than selector
        this.ui.modeWr.removeClass();
        this.ui.noteTypeIcon.attr('class', this._uiBindings.noteTypeIcon.replace('.', '') ); //remove prior icon class

        var children = this.children,
            searchView = children.findByCustom('searchView'),
            toolbar = children.findByCustom('toolbar');

        searchView.triggerMethod('toggleCollapseAbility');
        searchView.triggerMethod('toggleEnabled', 1);
        toolbar && toolbar.destroy();

    },
   /*
    *  If the active note type can change, was for anon notes.
    *  No enter/exit on note change
    * TODO: way too mixed with css from other hacks
    * */
    noteModelChanged: function(note, previousNote) {

        var newClass = 'pn-' + note.init,
            oldInitClass = 'pn-' + previousNote.init,
            oldIconClass =  previousNote.iconClass,
            newIconClass = note.iconClass;

        this.$el.removeClass(oldInitClass).addClass(newClass);
        this.ui.modeWr.removeClass(oldInitClass).addClass(newClass);
        this.ui.noteTypeIcon.removeClass(oldIconClass).addClass(newIconClass);

    },

    setFilterIndicatorAndTitle: function() {

        var notes = this.collection,
            notesAreFiltered = notes.notesAreFiltered();

        this.ui.filterBtn.toggleClass( 'filterActive', notesAreFiltered );

        var title = 'Filter';

        if (notesAreFiltered) {
            title += ':\n' + 'Showing ' + notes.getNumberOfVisibleNotes() + ' of ' + notes.length + ' notes';
        }

        this.ui.filterBtn.attr('title', title);

    },
    _setSortDirectionIndicator: function( dir ) {

        var sortedAscending = dir === 'asc';

        var caption =
            ( sortedAscending ? 'Ascending' : 'Descending' ) + ' order -- ' +
            'click to sort in ' + ( sortedAscending ? 'descending' : 'ascending' ) + ' order';

        this.ui.toggleSortBtn
            .removeClass('asc desc')
            .addClass(dir)
            .attr( 'title', caption );

    },

    /**
     * Note: currently this button will be displayed/enabled regardless of whether
     * redaction notes exist in the document.
     */
    _createPreviewRedactionToggleButton: function() {

        var vChannel = this.channel.request('vChannel'),
            BTN_TITLE = 'Preview Redactions';

        this.ui.previewRedactionToggleBtn.toggleButton({

            isActive: fvChannel.request('localStorage').getPgModeApplyAllRedactions(),
            toggleAction: function() {
                vChannel.command('toggleApplyAllRedactionsInPageMode');
            },
            activeTitle: BTN_TITLE,
            inactiveTitle: BTN_TITLE

        });

    },

    onBeforeDestroy: function() {

        BabySitterView.prototype.onBeforeDestroy.apply( this, arguments );

        this.ui.previewRedactionToggleBtn.destroy();

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/header.js
 ** module id = 487
 ** module chunks = 0
 **/